export default __webpack_public_path__ + "static/media/warning-icon.37854130.svg";